import MatchMedia from '@/js/core/MatchMedia'
import SwiperCore, { Navigation, Pagination, Scrollbar, Keyboard } from 'swiper/core'

export default class SwiperComponent extends MatchMedia {
  swiper = null

  selectors = {
    'swiperContainer': '.swiper-container',
    'swiperScrollbar': '.swiper-scrollbar',
    'swiperPagination': '.swiper-pagination',
    'swiperButtonPrev': '.swiper-button-prev',
    'swiperButtonNext': '.swiper-button-next',
  }

  state = {
    ...this.state,
    breakpointWatch: false,
  }

  actions = {
    breakpointSMMatches: 'setup'
  }

  created () {
    SwiperCore.use([ Navigation, Pagination, Scrollbar, Keyboard ])
  }

  setup () {
    const { breakpointSMMatches, breakpointWatch } = this.state

    if (breakpointSMMatches === undefined) return

    if (!breakpointWatch) {
      this.addSwiper()
      return
    }

    if (!breakpointSMMatches) {
      this.removeSwiper()
      return 
    }

    this.addSwiper()
  }

  addSwiper () {
    return
  }

  removeSwiper () {
    if (this.swiper) {
      this.swiper.destroy()
      this.swiper = null
    }
  }
}